import create from 'zustand'
import { persist } from 'zustand/middleware'

import {
  KINERJA_PENILIK_PERENCANAAN_PERILAKU_KERJA_DRAFT_STORAGE_KEY,
  KINERJA_PENILIK_PERENCANAAN_PRAKTIK_KINERJA_DRAFT_STORAGE_KEY,
  KINERJA_PENILIK_PERENCANAAN_PENGEMBANGAN_KOMPETENSI_DRAFT_STORAGE_KEY,
} from 'app/KinerjaPenilikPegawaiPage/configs'

import type { PerilakuKerjaAspek } from 'types/kinerja-penilik-pegawai'

type TPraktikKinerjaDraftStoreState = {
  draftPraktikKinerja?: string[]
  draftSatuanPendidikan?: string[]
  setDraft: (id: string[], ids: string[]) => void
  hasDraft: () => boolean
}
export const usePraktikKinerjaDraftStore =
  create<TPraktikKinerjaDraftStoreState>(
    persist(
      (set, get) => ({
        draftPraktikKinerja: undefined,
        draftSatuanPendidikan: [],
        setDraft: (praktikKinerjaIds = undefined, satuanPendidikanIds = []) =>
          set(() => ({
            draftPraktikKinerja: praktikKinerjaIds,
            draftSatuanPendidikan: satuanPendidikanIds,
          })),
        hasDraft: (): boolean =>
          (get()?.draftPraktikKinerja ?? []).length > 0 ||
          (get()?.draftSatuanPendidikan ?? []).length > 0,
      }),
      {
        name: KINERJA_PENILIK_PERENCANAAN_PRAKTIK_KINERJA_DRAFT_STORAGE_KEY,
      }
    )
  )

interface TPerilakuKerjaStoreState {
  selectedPerilakuKerja: PerilakuKerjaAspek[]

  hasDraft: () => boolean
  saveDraft: (perilakuKerja: Array<PerilakuKerjaAspek>) => void
}

export const usePerilakuKerjaStore = create<TPerilakuKerjaStoreState>(
  persist(
    (set, get) => ({
      selectedPerilakuKerja: [],
      saveDraft: (data) => {
        set((state) => {
          return {
            ...state,
            selectedPerilakuKerja: data,
          }
        })
      },
      hasDraft: (): boolean => {
        return get().selectedPerilakuKerja.length > 0
      },
    }),
    {
      name: KINERJA_PENILIK_PERENCANAAN_PERILAKU_KERJA_DRAFT_STORAGE_KEY,
    }
  )
)

type TPengembanganKompetensiDraftStoreState = {
  draftIndicator?: any
  draftActivities?: any[]
  setDraft: (indicator: any, activities: any[]) => void
  hasDraft: () => boolean
}
export const usePengembanganKompetensiDraftStore =
  create<TPengembanganKompetensiDraftStoreState>(
    persist(
      (set, get) => ({
        draftIndicator: undefined,
        draftActivities: [],
        setDraft: (indicator = undefined, activities = []) =>
          set(() => ({
            draftIndicator: indicator,
            draftActivities: activities,
          })),
        hasDraft: (): boolean =>
          Boolean(get()?.draftIndicator) ||
          (get()?.draftActivities ?? []).length > 0,
      }),
      {
        name: KINERJA_PENILIK_PERENCANAAN_PENGEMBANGAN_KOMPETENSI_DRAFT_STORAGE_KEY,
      }
    )
  )

export const STORES_WITH_STORAGE_KEY = [
  [
    usePraktikKinerjaDraftStore,
    KINERJA_PENILIK_PERENCANAAN_PRAKTIK_KINERJA_DRAFT_STORAGE_KEY,
  ],
  [
    usePerilakuKerjaStore,
    KINERJA_PENILIK_PERENCANAAN_PERILAKU_KERJA_DRAFT_STORAGE_KEY,
  ],
  [
    usePengembanganKompetensiDraftStore,
    KINERJA_PENILIK_PERENCANAAN_PENGEMBANGAN_KOMPETENSI_DRAFT_STORAGE_KEY,
  ],
]
